import { Injectable } from '@angular/core'
import { CanActivate } from '@angular/router'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class AuthenticationService implements CanActivate {
   private readonly _cn = this.constructor.name

   licenceSubject$: Subject<boolean> = new Subject<boolean>()

   constructor(
      private router: Router,
      public keycloakAngular: KeycloakService
   ) {
      keycloakAngular.keycloakEvents$.subscribe({
         next: (e) => {
            switch (e.type) {
               case KeycloakEventTypeLegacy.OnTokenExpired:
                  this.keycloakEventLog(e.type)
                  keycloakAngular.updateToken(5)
                  break
               case KeycloakEventTypeLegacy.OnAuthSuccess:
                  this.keycloakEventLog(e.type)
                  break
               case KeycloakEventTypeLegacy.OnAuthRefreshSuccess:
                  this.keycloakEventLog(e.type)
                  this.hasLicence().then((has) => this.licenceSubject$.next(has))
                  break
               case KeycloakEventTypeLegacy.OnAuthRefreshError:
                  this.keycloakEventLog(e.type)
                  keycloakAngular.login()
                  break
               default:
                  break
            }
         },
      })
   }

   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      if (!(await this.keycloakAngular.isLoggedIn())) {
         await this.keycloakAngular.login()
         return false
      }
      return true
   }

   ngOnDestroy(): void {
      this.keycloakAngular.keycloakEvents$.unsubscribe()
   }

   async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      return new Promise((resolve, reject) => {
         if (!this.keycloakAngular.isLoggedIn()) {
            this.keycloakAngular.login().catch((e) => console.error(e))
            reject(false)
         }
         resolve(true)
      })
   }

   logout() {
      this.keycloakAngular.logout()
   }

   async hasLicence(): Promise<boolean> {
      const roles = await this.keycloakAngular.getUserRoles(true)
      return roles.includes('LICENCE_LINKING_TOOL')
   }

   private keycloakEventLog(type: KeycloakEventTypeLegacy) {
      console.log(this._cn, 'Keycloak event - Type: ' + KeycloakEventTypeLegacy[type])
   }
}
